export default __webpack_public_path__ + "static/media/Consolidate.b6291e08.png";